import { MYMLState } from '../../types/mfc'
import {
    MYML_LOCATIONS,
    Recommendation,
} from '../mfcLogic/api/modelsYouMayLike'
import { pubSubMyml } from './pubSub'

export const MYMLSTATE: MYMLState = {
    [MYML_LOCATIONS.menu]: {
        results: [],
        id: null,
        timestamp: 0,
    },
    [MYML_LOCATIONS.recommendationPage]: {
        results: [],
        id: null,
        timestamp: 0,
    },
}
export enum MymlEvent {
    UPDATE_RESULTS = 'update_results',
}
if (typeof window !== 'undefined') {
    window.__MFC_APP_MYML__ = MYMLSTATE
}

export const setMymlResults = (
    id: number,
    results: Array<Recommendation>,
    location: MYML_LOCATIONS,
) => {
    MYMLSTATE[location] = {
        results,
        id,
        timestamp: +new Date(),
    }
    pubSubMyml.emit(MymlEvent.UPDATE_RESULTS, MYMLSTATE[location], false)
}
